import { Grid, Box, Text, Flex, Button } from '@chakra-ui/react';
import {
  QUERY_DISTRIBUTIONS,
  VARIABLES_DISTRIBUTIONS,
} from '@dapperlabs/core-fe';
import { useLoadMore, LoadMorePresenter } from '@dapperlabs/skeleton-core';
import React from 'react';
import { packOddsReduceSum } from 'src/lib/contentful/utils';
import { useTranslation } from 'src/lib/translations';

import { PreviousPackItem } from './PreviousPackItem';
export const PreviousPackList = () => {
  const { t } = useTranslation();
  const { onFetchMore, state } = useLoadMore({
    options: {
      context: {
        clientName: 'platformAPI',
      },
    },
    query: QUERY_DISTRIBUTIONS,
    queryDataPath: 'searchDistributions',
    queryPaginationPath: 'searchDistributions.pageInfo',
    variables: VARIABLES_DISTRIBUTIONS({
      first: 3,
      timeRangeEnd: new Date().toISOString().split('.')[0] + 'Z', // Milliseconds causes multiple re-renders
    }),
  });
  const { context, isFetching } = state;
  const { edges, pageInfo } = context;
  const previousDistributions = edges.map((e) => e?.node);
  const isNextPageAvailable = pageInfo?.hasNextPage;

  return (
    <LoadMorePresenter
      empty={<Text variant='value'>{t('MarketplaceSearch.NoResults')}</Text>}
      isEmpty={previousDistributions && previousDistributions.length === 0}
      state={state}
    >
      <Box>
        <Grid
          gap={3}
          templateColumns={{
            sm: 'repeat(2, 1fr)',
            xl: 'repeat(3, 1fr)',
          }}
        >
          {previousDistributions?.map((drop) => (
            <PreviousPackItem
              key={drop?.uuid}
              cardBg={drop?.images[1]?.url || ''}
              cardImg={drop?.images[0]?.url || ''}
              distributionId={drop?.id}
              packPrice={drop?.price?.value}
              packTitle={drop?.title}
              tier={drop?.tier}
              totalPacks={drop?.packOdds.reduce(packOddsReduceSum, 0)}
            />
          ))}
        </Grid>
        {isNextPageAvailable && (
          <Flex align='center' justify='center' mt={8} mb={8}>
            <Button isLoading={isFetching} onClick={onFetchMore}>
              {t('MarketplaceSearch.FetchMore')}
            </Button>
          </Flex>
        )}
      </Box>
    </LoadMorePresenter>
  );
};
